import React, { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
  withRepeat,
  withDelay,
} from 'react-native-reanimated';
import Colors from '../constants/Colors';

const Dot = ({ delay = 0, color = Colors.light.hereworksBlack600 }) => {
  const y = useSharedValue(0);

  useEffect(() => {
    y.value = withDelay(
      delay,
      withRepeat(
        withTiming(3, { duration: 300 }),
        -1,
        true,
      ),
    );
  }, []);

  const style = useAnimatedStyle(() => ({
    transform: [{ translateY: y.value }],
  }));

  return <Animated.View style={[styles.dot, style, { backgroundColor: color }]} />;
};

export default function BouncingDots() {
  return (
    <View style={styles.container}>
      <Dot delay={0} />
      <Dot delay={150} color={Colors.light.hereworksBlack200} />
      <Dot delay={300} color={Colors.light.hereworksBlack100} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    marginHorizontal: 3,
  },
});
